import React from "react";

const About = () => {
  return (
    <div className="bg-containx-navy min-h-screen p-6">
      <div className="max-w-4xl mx-auto bg-containx-navy text-white p-8">
        <h1 className="text-4xl font-bold text-center mb-6">About ContainX</h1>
        <p className="text-lg mb-4">
          ContainX is a family-run company committed to supplying high-quality,
          sustainable, and cost-effective packaging solutions to wholesalers,
          restaurants, and other food service providers. Our products are
          sourced from trusted manufacturers and are not only eco-friendly, but
          also easy & safe to use.
        </p>
        <p className="text-lg mb-4">
          As a small family business, we pride ourselves on providing the
          personalized service and attention to detail that you won't normally
          get from larger corporations. We are passionate about building close
          relationships with our customers and aim to offer reliability and
          top-notch customer support.
        </p>
        <h2 className="text-2xl font-semibold mt-4 mb-2">Our Vision</h2>
        <p className="text-lg text-gray-700 mb-4">
          We envision a world where food packaging is both environmentally
          friendly and practical. By utilizing sustainable materials and
          cutting-edge designs, we strive to reduce waste while maintaining
          functionality.
        </p>
        <h2 className="text-2xl font-semibold mt-4 mb-2">Our Commitment</h2>
        <p className="text-lg text-gray-700 mb-4">
          We are committed to quality and customer satisfaction. Our products
          undergo rigorous testing to ensure they meet industry standards,
          providing you with peace of mind and the best value for your business.
        </p>
        <h2 className="text-2xl font-semibold mt-4 mb-2">Why Choose Us?</h2>
        <ul className="list-disc list-inside mb-4">
          <li className="text-lg text-gray-700">
            Wide range of products tailored for various food service needs.
          </li>
          <li className="text-lg text-gray-700">
            Eco-friendly packaging solutions that support sustainable practices.
          </li>
          <li className="text-lg text-gray-700">
            Exceptional customer service and support.
          </li>
          <li className="text-lg text-gray-700">
            Competitive pricing without compromising on quality.
          </li>
        </ul>
        <p className="text-lg text-gray-700">
          Thank you for choosing ContainX as your trusted partner for packaging
          solutions. We look forward to serving you and contributing to your
          success!
        </p>
      </div>
    </div>
  );
};

export default About;
